module.exports = __webpack_public_path__ + "static/media/enzo.71ca1f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/enzo.png
// module id = 1153
// module chunks = 0